const removeDuplicatesArray = (array: any[]) => {
  return array.filter(
    (value, index, self) =>
      index ===
      self.findIndex(t => t.place === value.place && t.name === value.name),
  );
};

export { removeDuplicatesArray };
